import { c as _c } from "react/compiler-runtime";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
export const Descending = t0 => {
  const $ = _c(5);
  const {
    onClick,
    theme
  } = t0;
  let t1;
  if ($[0] !== theme) {
    t1 = {
      color: theme
    };
    $[0] = theme;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClick || $[3] !== t1) {
    t2 = <KeyboardArrowDownIcon sx={t1} aria-label="Sort Descending" onClick={onClick} />;
    $[2] = onClick;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};